import { render, staticRenderFns } from "./FooterEFTG.vue?vue&type=template&id=7913ed91"
import script from "./FooterEFTG.vue?vue&type=script&lang=js"
export * from "./FooterEFTG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports